var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFileCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.68421 3.63636H12.3158L18 9.09091V18.1818C18 19.1818 17.1473 20 16.1053 20H5.67473C4.63265 20 3.78947 19.1818 3.78947 18.1818L3.79896 5.45455C3.79896 4.45454 4.64213 3.63636 5.68421 3.63636ZM5.68421 5.45455V18.1818H16.1053V10H11.3684V5.45455H5.68421Z",
    fill: "#00A4EC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 12.7273C0 13.3333 0.378947 14.5455 1.89474 14.5455V1.81818H12.3158V0H1.89474C1.26316 0 0 0.363636 0 1.81818V12.7273Z",
    fill: "#00A4EC"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileCopy);
export default __webpack_public_path__ + "static/media/file_copy.d922dce80947e7c479f797746111b69d.svg";
export { ForwardRef as ReactComponent };